import { render } from "./Peppol.vue?vue&type=template&id=22ed5b8d&scoped=true"
import script from "./Peppol.vue?vue&type=script&lang=js"
export * from "./Peppol.vue?vue&type=script&lang=js"

import "./Peppol.vue?vue&type=style&index=0&id=22ed5b8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ed5b8d"]])

export default __exports__